import type { ObjectiveType, QuestDef } from './data/quests';

/**
 * Counts one event on a quest's matching objectives (mutates `prog`, one slot per objective).
 * Strict (default): an objective with a target needs the same target. `loose`: an objective
 * with a target also matches when the event carries no target.
 * Returns 'ready' when every objective is full, 'progress' when something moved, else null.
 */
export function advanceObjectives(
  q: QuestDef,
  prog: number[],
  type: ObjectiveType,
  target: string | undefined,
  opts: { loose?: boolean } = {},
): 'ready' | 'progress' | null {
  let changed = false;
  q.objectives.forEach((o, i) => {
    if (o.type !== type) return;
    if (o.target && (opts.loose ? target && o.target !== target : o.target !== target)) return;
    const cur = prog[i] ?? 0;
    if (cur < o.count) {
      prog[i] = cur + 1;
      changed = true;
    }
  });
  if (!changed) return null;
  return q.objectives.every((o, i) => (prog[i] ?? 0) >= o.count) ? 'ready' : 'progress';
}
